import React from 'react';
import './Spinner.css';

/**
 * Reusable Spinner component for loading indicators
 * Requirements: 8.2 - Display loading indicators for async operations
 * 
 * @param {Object} props
 * @param {string} props.size - Size of spinner: 'small', 'medium', 'large' (default: 'medium')
 * @param {string} props.message - Optional message to display below spinner
 */
function Spinner({ size = 'medium', message }) {
  return (
    <div className="spinner-container">
      <div className={`spinner spinner-${size}`}></div>
      {message && <p className="spinner-message">{message}</p>}
    </div>
  );
}

export default Spinner;
